import React from 'react';
import assessment from './assests/assessment.png';
import Button from '../../../../ui-core/Button/Button';
import PropTypes from 'prop-types';
import './style.css';
import { useNavigate } from 'react-router';
import { APP_ROUTES } from '../../../../route';
import { getItem } from '../../../../utils/cache';
import { extractJSON } from '../../../../services/jsonUtil';
import { LOCAL_STORAGE_CONSTANT } from '../../../../constants/app';

const AssessmentModal = props => {
  const navigate = useNavigate();
  const userData = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const isNewUser = userData?.attributes?.new_user;
  const sessiondata = JSON.parse(getItem(LOCAL_STORAGE_CONSTANT.SESSION));
  const provider = sessiondata?.provider;
  const isAppleLogin = getItem('isAppleLogin');
  const isFromCoursePage = getItem('isFromCoursePage');
  // const completeOnboarding = JSON.parse(getItem('completeOnboarding'));

  const handleSkip = () => {
    const coursePageRedirectUrl = extractJSON('coursePageRedirectUrl');
    props.handleModalEvent(null);
    const isOfflineCheckout = JSON.parse(getItem('isOfflineCheckout'));
    if (isOfflineCheckout) {
      localStorage.setItem(
        'checkoutFromSignup',
        JSON.stringify({ status: true }),
      );
    }
    const isRedirectCourse = getItem('redirectToCourse');
    if (isRedirectCourse && props?.handleClose) {
      props?.handleClose();
    } else {
      if (coursePageRedirectUrl) {
        navigate(coursePageRedirectUrl);
      } else {
        navigate(APP_ROUTES.HOME);
      }
    }
  };

  const handleGoAssessment = () => {
    if (
      isNewUser ||
      ((provider === 'google' || isAppleLogin) &&
        !userData?.attributes?.onboarding_completed &&
        isFromCoursePage) ||
      (sessiondata && !userData?.attributes?.onboarding_completed)
    ) {
      navigate(APP_ROUTES.SIGNUP_ONBOARDING);
      props.handleModalEvent(null);
    } else {
      navigate(APP_ROUTES.ASSESSMENT_ONBOARDING);
    }
  };
  return (
    <div className="" style={{ zIndex: '2' }}>
      <div className="d-flex justify-content-center">
        <img src={assessment} alt="assessment" />
      </div>
      <div className="assessment_content text-center d-flex justify-content-center align-items-center flex-column mt-5">
        <h3>Let&apos;s begin your personalized assessment</h3>
        <span>
          This assessment helps us to better understand your goals and better
          guide your journey on this platform!
        </span>
      </div>
      <div className="mt-5 text-center">
        <span className="skip-content" onClick={() => handleSkip()}>
          Skip for now
        </span>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <Button
          text={
            <div>
              CONTINUE{' '}
              <span style={{ fontSize: '25px', fontWeight: '400' }}>{'>'}</span>
            </div>
          }
          class={'question-fill-button w-100 continue-btn'}
          onClick={() => handleGoAssessment()}
        />
      </div>
    </div>
  );
};

AssessmentModal.propTypes = {
  handleModalEvent: PropTypes.func,
  handleClose: PropTypes.func,
};

export default AssessmentModal;
